import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en, fr, ar } from './locales';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en,
      fr,
      ar,
    },
    fallbackLng: 'en',
    interpolation: {
      // Keep escaping ON. React already escapes children, but interpolated
      // variables flowing through `t('key', { name })` should ALSO be
      // escaped so that any future use of the translation in a non-text
      // context (e.g. dangerouslySetInnerHTML) stays safe by default.
      escapeValue: true,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;